import { o365OauthClientId, o365OauthTenantId } from "./config";
import { getCurrentEnv, getPublicUrl, isRevIntelSite } from "./appConfig";

const authorityUrl = () => {
  return getCurrentEnv() === "prod"
    ? "https://login.microsoftonline.com/common"
    : `https://login.microsoftonline.com/${o365OauthTenantId}`;
};

// The revintel site is a standalone origin. getPublicUrl() always resolves to
// the main app URL, so using it as the MSAL redirectUri sends revintel logins
// to the main app. On revintel, return to a blank page on the same origin:
// landing on the SPA root would let React Router clear the auth hash before
// MSAL reads it (hash_empty_error), so blank.html keeps the hash intact.
const redirectUri = () =>
  isRevIntelSite() ? `${window.location.origin}/blank.html` : getPublicUrl();

export const msalConfig = {
  auth: {
    clientId: o365OauthClientId,
    authority: authorityUrl(),
    redirectUri: redirectUri(),
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "login",
};

export const AuthErrorCodes = {
  userCancelled: "user_cancelled",
};
